var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import CurrentPageMixin from './mixin/current-page';
var PageButton = /** @class */ (function (_super) {
    __extends(PageButton, _super);
    function PageButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isProcessingJump = false;
        return _this;
    }
    Object.defineProperty(PageButton.prototype, "isCurrentLocal", {
        get: function () {
            if (this.isCurrent == null) {
                return this.currentPage == this.number;
            }
            else {
                return this.isCurrent();
            }
        },
        enumerable: false,
        configurable: true
    });
    PageButton.prototype.jump = function (pageNumber) {
        var _this = this;
        this.isProcessingJump = true;
        this.$emit('jump', pageNumber, function () {
            _this.isProcessingJump = false;
        });
    };
    __decorate([
        Prop({ type: Boolean })
    ], PageButton.prototype, "isLoading", void 0);
    __decorate([
        Prop({ type: Object })
    ], PageButton.prototype, "pagination", void 0);
    __decorate([
        Prop({ type: Number })
    ], PageButton.prototype, "number", void 0);
    __decorate([
        Prop({ type: Function })
    ], PageButton.prototype, "isCurrent", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], PageButton.prototype, "highlightIfCurrent", void 0);
    PageButton = __decorate([
        Component({
            components: {},
        })
    ], PageButton);
    return PageButton;
}(Mixins(CurrentPageMixin)));
export default PageButton;
